module.exports = __webpack_public_path__ + "assets/img/init_pos_wallpaper6.5f80e57f.png";